"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppleAuthTokenErrorNotificationSchema = exports.AppleAuthTokenErrorNotificationPayloadSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.AppleAuthTokenErrorNotificationPayloadSchema = (0, core_1.StrictObject)({
    parentOrgRef: typebox_1.Type.String(),
    authError: typebox_1.Type.String(),
    teamId: core_1.IdSchema,
});
exports.AppleAuthTokenErrorNotificationSchema = (0, ruby_1.createNotificationMessageSchema)(ruby_1.NotificationType.APPLE_AUTH_TOKEN_ERROR, exports.AppleAuthTokenErrorNotificationPayloadSchema);
